module.exports = __webpack_public_path__ + "static/images/icon-apple-new4.79a1e79.png";